import React from 'react';

import { DAILY_NEWS } from '../../Pages';
import { CONTENT_TYPES } from '../../../core/constants';

export default {
  path: DAILY_NEWS.pageURL,
  async action() {
    const { default: CommonManager } =
      await import('../common/ContentManagerView/CommonManager');
    return (
      <CommonManager
        key={'list'}
        contentType={CONTENT_TYPES.DAILY_NEWS}
        page={DAILY_NEWS}
      />
    );
  },
};
